// TICKET: https://npco-dev.atlassian.net/browse/TECH-395
// Should move this to a separate nx library
export const TOOLTIP_ZINDEX = '10004'
